import Icon from 'vue-awesome/components/Icon'

Icon.register({
  alarm_off_rounded: {
    paths: [
      {
        d: 'M10.04 6.29C10.66 6.11 11.32 6 12 6c3.86 0 7 3.14 7 7 0 .68-.11 1.34-.29 1.96l1.56 1.56c.47-1.08.73-2.27.73-3.52A9 9 0 008.47 4.72l1.57 1.57zm-6.33-3.5a.99.99 0 00-1.39 0l-.02.03a.972.972 0 000 1.39l.68.68-.17.14c-.42.34-.47.96-.13 1.38l.03.03c.35.42.96.47 1.38.12l.31-.25.8.8A8.964 8.964 0 003 13a9 9 0 009 9c2.25 0 4.31-.83 5.89-2.2l1.41 1.41c.38.38 1 .38 1.39 0l.03-.03c.38-.38.38-1 0-1.39l-17.01-17zM12 20c-3.86 0-7-3.14-7-7 0-1.7.61-3.26 1.62-4.47l9.85 9.85A6.956 6.956 0 0112 20z'
      },
      {
        d: 'M19.91 6.56c.42.35 1.03.29 1.38-.12l.03-.03a.981.981 0 00-.12-1.38l-3.1-2.59a.981.981 0 00-1.38.12l-.03.03a.981.981 0 00.12 1.38l3.1 2.59zM7.43 3.68c.18-.34.15-.77-.11-1.09l-.03-.03c-.3-.36-.8-.43-1.2-.22l1.34 1.34z'
      }
    ],
    width: '24',
    height: '24'
  }
})
